<!-- Breadcrumb -->
<div
    class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between"
>
    <h5 class="mb-0">Die</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 p-0">
        <li class="breadcrumb-item d-inline-block position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="material-symbols-outlined"> home </i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item d-inline-block position-relative">Die</li>
        <li class="breadcrumb-item d-inline-block position-relative">
            Die List
        </li>
    </ol>
</div>

<div
    class="crm-leads-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
>
    <div
        class="trezo-card-header d-sm-flex align-items-center justify-content-between"
    >
        <div class="trezo-card-title">
            <h5 class="mb-0">Die List</h5>
        </div>
        <div class="trezo-card-subtitle">
            <button
                class="add-btn d-inline-block transition fw-medium border-radius"
                type="button"
                (click)="onAddClick()"
            >
                <span class="d-inline-block position-relative">
                    <i class="material-symbols-outlined"> add </i>
                    Add New Die
                </span>
            </button>
        </div>
    </div>
    <div class="trezo-card-content">
        <app-table
            [datasource$]="dieService.data$"
            [columns]="columns"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [actionButtons]="actions"
            [sortable]="true"
            [usePagination]="true"
            [useFilter]="false"
            [queryParameters]="searchOptions"
            [resultLength]="totalRecords"
            [useStickyHeaders]="false"
            [allowRowSelection]="true"
            [allowDragDrop]="false"
            [isExpandable]="true"
            [expandColumn]="expandColumn"
            (eventHandler)="tableEvent($event)"
        >
            <ng-template let-row>
                <!-- TODO: need to uncomment <td>
                      <a hr="#" (click)="onActionClick($event, detail)">{{ getOrgName(detail)}}</a>
                    </td>-->

                <div class="row">
                    <!-- Image Section -->
                    <div class="col-md-4 text-center">
                        <img
                            [src]="getImageUrl(row.photoUrl)"
                            alt="Die Image"
                            style="
                                width: 370px;
                                height: 270px;
                                border-radius: 10px;
                                border: 1px solid #ccc;
                            "
                        />
                    </div>

                    <!-- Die Details Table Section -->
                    <div class="col-md-8">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Section No</th>
                                    <th>A</th>
                                    <th>B</th>
                                    <th>T</th>
                                    <th>Weight</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let detail of row.dieDetails">
                                    <td>{{ detail.sectionNo }}</td>
                                    <td>{{ detail.a }}</td>
                                    <td>{{ detail.b }}</td>
                                    <td>{{ detail.t }}</td>
                                    <td>{{ detail.weight }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-template>
        </app-table>
    </div>
</div>

<!-- Add New Popup -->
<div class="add-new-popup" [class.active]="classApplied">
    <app-die-details
        *ngIf="classApplied"
        [currentDieId]="dieId"
        (saveConfirmationEvent)="saveConfirmationEvent($event)"
        (classApplied)="classAppliedEvent($event)"
    />
</div>

<!-- Add this to your die-list.component.html (after your existing content) -->

<!-- Image Modal -->
<div
    class="modal fade"
    [class.show]="showImageModal"
    [style.display]="showImageModal ? 'block' : 'none'"
    tabindex="-1"
    role="dialog"
    *ngIf="showImageModal"
>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ selectedImageTitle }}</h4>
                <button
                    type="button"
                    class="btn-close"
                    (click)="closeImageModal()"
                    aria-label="Close"
                ></button>
            </div>
            <div class="modal-body text-center">
                <img
                    [src]="selectedImageUrl"
                    [alt]="selectedImageTitle"
                    class="img-fluid"
                    style="max-height: 500px; border-radius: 8px"
                />
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="closeImageModal()"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal backdrop -->
<div
    class="modal-backdrop fade"
    [class.show]="showImageModal"
    *ngIf="showImageModal"
    (click)="closeImageModal()"
></div>
